import { UIState } from "@hydra/core/uiState";
import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class Hero implements Plugin {
  private unsubscribeCurrentBreakpoint?: () => void;
  private readonly variant: string;
  private readonly desktopContent: HTMLElement | null;
  private readonly mobileTitle: HTMLElement | null;
  private readonly mobileCaption: HTMLElement | null;

  constructor(private readonly element: HTMLElement) {
    this.variant = this.element.dataset.variant || "1";

    this.desktopContent = this.element.querySelector("[data-desktop-content]");
    this.mobileTitle = this.element.querySelector("[data-mobile-title]");
    this.mobileCaption = this.element.querySelector("[data-mobile-caption]");
  }

  init(): void {
    if (this.element.classList.contains("dsc-co-hero--search-only")) {
      return;
    }

    const uiState = UIState.getInstance();
    this.unsubscribeCurrentBreakpoint = uiState.subscribe(
      "currentBreakpoint",
      () => this.handleBreakpointChange(uiState),
    );
    this.handleBreakpointChange(uiState);
  }

  private handleBreakpointChange(uiState: UIState): void {
    const isMobile = uiState.isMobile || uiState.isTablet;

    if (this.desktopContent) {
      this.desktopContent.classList.toggle(
        "dsc-co-hero__desktop-content--hidden",
        isMobile,
      );
    }

    if (this.mobileTitle && this.variant !== "2") {
      this.mobileTitle.classList.toggle(
        "dsc-co-hero__mobile-title--visible",
        isMobile,
      );
    }

    if (this.mobileCaption && this.variant !== "2") {
      this.mobileCaption.classList.toggle(
        "dsc-co-hero__mobile-caption--visible",
        isMobile,
      );
    }
  }

  destroy(): void {
    if (this.unsubscribeCurrentBreakpoint) {
      this.unsubscribeCurrentBreakpoint();
      this.unsubscribeCurrentBreakpoint = undefined;
    }
  }
}

PluginRegistry.register("hero", Hero);
